import { css } from 'styled-components';

import { CommonTheme, ManualCSSTheme } from 'app/shared/theme';

export interface WithBackgroundProps {
  backgroundColor?: string;
  backgroundPosition?: string;
  backgroundGrayscale?: boolean;
  backgroundGradient?: string;
  hoverBackgroundGradient?: string;
  backgroundImage?: string | string[];
  hoverBackgroundColor?: string;
}

interface WithBackgroundCSSProps extends WithBackgroundProps {
  theme: CommonTheme | ManualCSSTheme;
}

interface BackgroundImageProps {
  backgroundImage: string | string[];
  theme: CommonTheme | ManualCSSTheme;
}
const generateBackgroundImageCSS = ({
  theme,
  backgroundImage,
}: BackgroundImageProps) => {
  let styles: any[] = [
    'background-repeat: no-repeat;',
    'background-size: cover;',
    'background-blend-mode: multiply;',
  ];

  if (typeof backgroundImage === 'string') {
    styles.push(css`background-image: url(${backgroundImage});`);
  } else if (Array.isArray(backgroundImage)) {
    styles.push('background-position: center;');

    const breakPointKeys = Object.keys(theme.breakPoints);

    backgroundImage.forEach((image: string, index: number) => {
      const breakpointKey = breakPointKeys[index];
      const mediaQuery = theme.utils.getMediaQuery(breakpointKey);

      styles.push(mediaQuery`background-image: url(${image});`);
    });
  }

  return styles;
};

export const withBackgroundCSS = ({
  theme,
  backgroundColor,
  backgroundGrayscale,
  backgroundImage,
  backgroundGradient,
  hoverBackgroundGradient,
  backgroundPosition,
  hoverBackgroundColor,
}: WithBackgroundCSSProps) => css`
  ${backgroundPosition && `background-position: ${backgroundPosition};`}
  ${backgroundColor && `background-color: ${backgroundColor};`}
  ${backgroundGradient && `background: ${backgroundGradient};`}
  ${backgroundGrayscale && 'filter: grayscale(100%);'}
  ${
    hoverBackgroundColor &&
    `&:hover {
      background-color: ${hoverBackgroundColor};
    }`
  }
  ${
    hoverBackgroundGradient &&
    `&:hover {
      background: ${hoverBackgroundGradient};
    }`
  }
  ${backgroundImage && generateBackgroundImageCSS({ theme, backgroundImage })}
`;
